export const trainListCn = {
    placeholder:"请输入服务关键字",
    feiyong:"费用",
    spxx:'商品信息',
    dingdh:'订单号',
    xdsj:'下单时间',
    pxfwlx:'培训服务类型',
    jcrz:'检测认证',
    ddze:'订单总额',
    khzh:'客户账号',
    tcxx: '套餐信息',
    ddzt:'订单状态',
    fwmc:'服务名称',
    dangjia:'单价',
    keshi:'课时',
    heji:'合计',
    xfjyfw:'消费品检验服务',
    zfxx:'支付信息',
    fkfs:'付款方式',
    fksj:'付款时间',
    fwje:'服务金额',
    yzfje:'应支付金额',
    youhuiq:'优惠券',
    ddyh:'订单优惠',
    fhddlb:'返回培训订单列表',
    ddqr:'订单确认',
    ddzf:'订单支付',
    ddwc:'订单完成'
}


// WEBPACK FOOTER //
// ./src/lang/home/trainList/indexCn.js